<template>
  <div class="body-wrapper">
    <div>
      <h4>Računi</h4>
      <div class="table-wrapper">
        <spinner class="spinner" line-fg-color="#00796b" :size="100" :line-size="6" v-if="loading"></spinner>
        <div v-show="!loading">
          <div class="btns-wrapper">
            <button class="btn btn-primary" @click="showModalWider('ModalContentInvoice')">
              <span>Novi račun</span>
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <data-table
            :columns="tableColumns"
            :tableData="tableData"
            :options="tableOptions"
            :slotNameActionCommunityFinancesInvoices="'action'"
            :slotInvoiceTotalAmount="'total_amount'"
            @invoicesEmailClick="handleEmailClick"
            @invoicesPdfClick="handlePdfClick"
          ></data-table>
        </div>
      </div>
    </div>
    <modal-confirm-action
      message="Da li ste sigurni da pošaljete račun članovima putem mail-a?"
      v-if="showConfirmModal"
      @close="showConfirmModal = !showConfirmModal"
      @confirm="processConfirmAction"
    >
      <div class="print_opt">
        <h5>Pošaljite email</h5>
        <label class="container">
          svim članovima
          <input type="radio" name="radio" value="all" v-model="emailOption" />
          <span class="checkmark"></span>
        </label>
        <label class="container">
          članovima koji nemaju aplikaciju
          <input
            type="radio"
            name="radio"
            value="onlyWithoutApp"
            v-model="emailOption"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </modal-confirm-action>
  </div>
</template>
<script>
import DataTable from '@/components/community/Table';
import axios from '@/axios/axios.js';
import { financesInstance } from '@/axios/axios.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import modalConfirmAction from '@/components/modal/ModalConfirmAction.vue';
import Checkbox from '@/components/common/Checkbox.vue';

export default {
  name: 'CommunityInvoices',
  components: {
    DataTable,
    modalConfirmAction,
    Checkbox
  },
  data() {
    return {
      showConfirmModal: false,
      emailOption: 'all',
      activeInvoice: null
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('finances', ['invoices']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  async created() {
    this.setTableBadge('fas fa-cash-register');
    //setting up table options and table column names
    this.initTable('communityFinancesInvoicesTable');
    await this.getTableData({
      communityId: this.$store.getters.getActiveCommunity.id,
      tableName: 'invoices'
    });

    this.setTableData(this.invoices.data);
  },
  methods: {
    ...mapActions('table', ['initTable']),
    ...mapMutations('modal', ['showModalWider']),
    ...mapMutations('table', ['setTableBadge', 'setTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('finances', ['getTableData']),
    async processConfirmAction() {
      //email
      try {
        const { data: details } = await this.getInvoiceDetails(
          this.activeInvoice.id
        );
        const memberIds = [];
        if (this.emailOption == 'all') {
          for (const member of details.members) {
            memberIds.push(member.id);
          }
        } else {
          for (const member of details.members) {
            if (member.member_id) {
              memberIds.push(member.id);
            }
          }
        }
        await this.sendEmail(this.activeInvoice.id, memberIds);
      } catch (err) {
        console.log(err);
        this.showFailModal();
      } finally {
        this.showConfirmModal = false;
      }
    },
    handleEmailClick(data) {
      this.activeInvoice = data.row;
      this.showConfirmModal = true;
    },
    async handlePdfClick(data) {
      this.activeInvoice = data.row;
      const rowIndex = this.invoices.data.findIndex(
        i => i.id === this.activeInvoice.id
      );
      this.invoices.data[rowIndex].isLoading = true;
      this.invoices.data.splice(rowIndex, 1, this.invoices.data[rowIndex]);
      try {
        const { data: details } = await this.getInvoiceDetails(
          this.activeInvoice.id
        );

        const memberIds = [];

        for (let member of details.members) {
          memberIds.push(member.id);
        }
        this.downloadPdfs(this.activeInvoice.id, memberIds, rowIndex);
      } catch (err) {
        console.log(err);
        this.invoices.data[rowIndex].isLoading = false;
        this.invoices.data.splice(rowIndex, 1, this.invoices.data[rowIndex]);
        this.showFailModal();
      }
    },
    downloadPdfs(invoiceId, memberIds, rowIndex) {
      return financesInstance
        .post(
          '/members/invoicesInPdf',
          {
            invoiceId: invoiceId,
            memberIds: memberIds,
            sendOnlyToNonAppMembers: false
          },
          {
            responseType: 'blob'
          }
        )
        .then(({ data }) => {
          let fileURL = window.URL.createObjectURL(new Blob([data]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            this.activeInvoice.description + '.pdf'
          );
          document.body.appendChild(fileLink);
          this.invoices.data[rowIndex].isLoading = false;
          this.invoices.data.splice(rowIndex, 1, this.invoices.data[rowIndex]);
          fileLink.click();
        })
        .catch(err => {
          this.invoices.data[rowIndex].isLoading = false;
          this.invoices.data.splice(rowIndex, 1, this.invoices.data[rowIndex]);
          this.showFailModal();
        });
    },
    sendEmail(invoiceId, memberIds) {
      financesInstance
        .post('/members/sendInvoiceToMail', {
          invoiceId: invoiceId,
          memberIds: memberIds
        })
        .then(res => {
          this.showSuccessModal();
        });
    },
    getInvoiceDetails(invoiceId) {
      return financesInstance.get(`invoices/${invoiceId}`);
    }
  },
  destroyed() {
    //unsetting table badge
    this.setTableBadge('');
  }
};
</script>
<style lang="scss" scoped>
h4 {
  position: relative;
  margin-bottom: 1rem;
}
.btns-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  .btn {
    width: 150px;
    margin-right: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
